<!-- Tooltip.vue -->
<template>
  <div
    v-if="visible"
    class="tooltipGraph"
    :style="{ left: `${position.x}px`, top: `${position.y}px` }"
  >
    <div v-html="content" />
  </div>
</template>

<script>
export default {
    name: 'Tooltip',
    props: {
        content: String,
        position: {
            type: Object,
            default: () => ({ x: 0, y: 0 }),
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

  <style>
  .tooltipGraph {
    position: absolute;
    background-color: #26384b;
    padding: 5px;
    pointer-events: none;
    z-index: 1000;
    color: #fff;
  }
  </style>
